export default __webpack_public_path__ + "static/954-c606c1338cf64042647ac71b6d8b421d.gif";